import BaseApi from './baseApi';
import IListStatusOutbound from '../models/IListStatusOutbound';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusOutboundsDeliveryNotesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetListStatusOutboundDeliveryNotes() : Promise<IListStatusOutbound[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusOutbound: IListStatusOutbound[] = [];
            listStatusOutbound = response.data as IListStatusOutbound[];
            return listStatusOutbound;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusOutboundsDeliveryNotes",
                "Item2": "id"
            }, {
                "Item1": "ListStatusOutboundsDeliveryNotes",
                "Item2": "name"
            }, {
                "Item1": "ListStatusOutboundsDeliveryNotes",
                "Item2": "isFinished"
            }],
            "tables": [{
                "Item1": "ListStatusOutboundsDeliveryNotes"
            }],
            "conditions": [{
                "Item1": "ListStatusOutboundsDeliveryNotes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "ListStatusOutboundsDeliveryNotes.name"
            }]
        };
        return json;
    }
}
